import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai"
import works from "services/works"
import { WorkCarousel } from ".."
import { FiArrowRight } from "react-icons/fi"
import moment from "moment"

export default ({ setPageType, setLoading, setRefresh, refresh }) => {
  const { t } = useTranslation()
  const [data, setData] = useState([])
  const prevRef = useRef(null)
  const nextRef = useRef(null)

  useEffect(() => {
    works
      .getAll({
        year: moment().format("YYYY"),
        limit: 20,
        page: 1,
      })
      .then((res) => {
        setData(res?.docs?.filter((item) => item?.seen !== 0))
      })
      .catch((err) => console.log(err))
  }, [refresh])

  return (
    <div className="mt-[10px] md:mt-24">
      {data?.length > 0 && (
        <>
          <div>
            <p className="text-xl font-medium text-black">{t("mostViewed")}</p>
          </div>
          <div className="pb-5">
            <div className="relative top-0 w-full py-1 md:py-4">
              <div className="py-6">
                <WorkCarousel
                  setRefresh={setRefresh}
                  setLoading={setLoading}
                  data={data}
                  prevRef={prevRef}
                  nextRef={nextRef}
                />
                <div className="flex justify-between gap-4 py-5">
                  <button
                    className="md:hidden text-[color:black] font-semibold text-base underline flex justify-start items-center gap-2"
                    onClick={() => setPageType("gridList")}
                  >
                    <span>Барчасини кўриш</span>{" "}
                    <span className="mt-[4px]">
                      <FiArrowRight size={20} />
                    </span>
                  </button>
                  <div className="flex justify-end gap-3">
                    <button
                      ref={prevRef}
                      className="block md:absolute top-1/2 -left-6 text-2xl text-primary-text-color rounded-full bg-white p-3 hover:text-white hover:bg-[color:var(--custom-secondary)] shadow-md hover:shadow-[color:var(--custom-secondary-hover)] z-20"
                    >
                      <AiOutlineLeft aria-hidden="true" />
                    </button>
                    <button
                      ref={nextRef}
                      className="block md:absolute top-1/2 -right-6 text-2xl text-primary-text-color rounded-full bg-white p-3 hover:text-white hover:bg-[color:var(--custom-secondary)] shadow-md hover:shadow-[color:var(--custom-secondary-hover)] z-20"
                    >
                      <AiOutlineRight aria-hidden="true" />
                    </button>
                  </div>
                  {/* <button
                    onClick={() => setPageType("gridList")}
                    className="hidden md:flex justify-start items-center gap-1 md:absolute -bottom-10 right-0 z-20 text-base text-[color:var(--custom-secondary)] hover:underline"
                  >
                    Барчасини кўриш
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
